import { CheckCircle2, XCircle, Eye, EyeOff } from "lucide-react";
import type { LucideIcon } from "lucide-react";

type BooleanIconTheme = "check" | "eye";

export interface BooleanIconProps {
  value: boolean | null | undefined;
  /** Icon theme: "check" (default) = CheckCircle/XCircle, "eye" = Eye/EyeOff */
  theme?: BooleanIconTheme;
  /** Custom on/off icons — overrides theme */
  onIcon?: LucideIcon;
  offIcon?: LucideIcon;
  /** Size — preset name or px number */
  size?: "sm" | "md" | "lg" | number;
  className?: string;
}

const SIZE_MAP: Record<string, number> = { sm: 14, md: 16, lg: 20 };

const ICONS: Record<BooleanIconTheme, { on: LucideIcon; off: LucideIcon }> = {
  check: { on: CheckCircle2, off: XCircle },
  eye: { on: Eye, off: EyeOff },
};

export function BooleanIcon({ value, theme = "check", onIcon, offIcon, size = "md", className }: BooleanIconProps) {
  const icons = ICONS[theme];
  const Icon = value ? (onIcon ?? icons.on) : (offIcon ?? icons.off);
  const color = value ? "var(--mantine-color-green-5)" : "var(--mantine-color-dimmed)";
  const px = typeof size === "number" ? size : SIZE_MAP[size] ?? 16;

  return <Icon size={px} className={className} style={{ color, flexShrink: 0 }} />;
}
